<ng-container *ngIf="showSpinner">

  <div class="loading-container">

    <div class="d-flex justify-content-center">

      <!-- <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->

      <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</ng-container>
